import { render } from "./resetPassword.vue?vue&type=template&id=f2f85e52&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=f2f85e52&scoped=true&lang=css"
import "./resetPassword.vue?vue&type=style&index=1&id=f2f85e52&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f85e52"]])

export default __exports__